<template>
  <div>
    <InfoBanner page="deposit" />
    <div class="invest container">
      <div class="row">
        <div class="col-lg-12">
          <loader v-show="isLoading" />
          <div v-if="!isLoading" class="container">
            <stepper :steps="steps" @setstep="setStep" />
            <div class="row">
              <div class="col-12 col-md-7 col-lg-7 col-xl-7">
                <before-form-header
                  :title="'views.deposit.depositFunds'"
                  :description="'views.deposit.depositFundsStart'"
                />
                <b-form>
                  <div class="form-group">
                    <div>
                      <label class="typo__label">{{
                        $t("views.deposit.selectCurrency")
                      }}</label>
                      <select class="custom-select">
                        <option selected value="EUR">
                          {{ $t("views.deposit.euro") }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    {{ $t("views.deposit.selectDepositMethod")
                    }}<b-form-select
                      v-model="methods.selected"
                      :options="methods.options"
                      rel="depositMethod"
                    ></b-form-select>
                  </div>
                  <div class="form-group">
                    <strong>{{
                      $t("views.deposit.instructionsForBankTransfer")
                    }}</strong>
                    <div>{{ instruction }}</div>
                    <div>{{ instructionDeposit }}</div>
                    <div>
                      <strong>{{ $t("views.deposit.acceptOnlySepa") }}</strong>
                    </div>
                    <div style="color: red">
                      <strong>{{ $t("views.deposit.nbAccountChange") }}</strong>
                    </div>
                  </div>
                </b-form>
                <div>
                  <b-table-simple class="table company-info">
                    <b-tbody>
                      <b-tr>
                        <b-th>{{ $t("views.deposit.beneficiary") }}</b-th>
                        <b-td v-model="companyInfo.companyName">{{
                          companyInfo.companyName
                        }}</b-td>
                        <b-td>
                          <img
                            id="copy_company_name"
                            class="copy"
                            alt="Copy to Clipboard"
                            v-bind:src="getSrc('copy.svg')"
                            v-clipboard="companyInfo.companyName"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          />
                          <b-tooltip
                            target="copy_company_name"
                            triggers="hover"
                            >{{
                              $t("views.deposit.copyToClipboard")
                            }}</b-tooltip
                          >
                          <b-tooltip
                            target="copy_company_name"
                            triggers="click"
                            >{{
                              $t("views.deposit.copiedToClipboard")
                            }}</b-tooltip
                          >
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t("views.deposit.bank") }}</b-th>
                        <b-td v-model="companyInfo.bank">{{
                          companyInfo.bank
                        }}</b-td>
                        <b-td
                          ><img
                            id="copy_bank"
                            class="copy"
                            alt="Copy to Clipboard"
                            v-b-tooltip.hover
                            :title="$t('views.deposit.copyToClipboard1')"
                            v-bind:src="getSrc('copy.svg')"
                            v-clipboard="companyInfo.bank"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          />
                          <b-tooltip target="copy_bank" triggers="hover">{{
                            $t("views.deposit.copyToClipboard2")
                          }}</b-tooltip>
                          <b-tooltip target="copy_bank" triggers="click">{{
                            $t("views.deposit.copiedToClipboard1")
                          }}</b-tooltip>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t("views.deposit.iban") }}</b-th>
                        <b-td v-model="companyInfo.iban">{{
                          companyInfo.iban
                        }}</b-td>
                        <b-td
                          ><img
                            id="copy_iban"
                            class="copy"
                            alt="Copy to Clipboard"
                            v-b-tooltip.hover
                            :title="$t('views.deposit.copyToClipboard3')"
                            v-bind:src="getSrc('copy.svg')"
                            v-clipboard="companyInfo.iban"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          />
                          <b-tooltip target="copy_iban" triggers="hover">{{
                            $t("views.deposit.copyToClipboard4")
                          }}</b-tooltip>
                          <b-tooltip target="copy_iban" triggers="click">{{
                            $t("views.deposit.copiedToClipboard2")
                          }}</b-tooltip>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t("views.deposit.swiftbic") }}</b-th>
                        <b-td v-model="companyInfo.swift">{{
                          companyInfo.swift
                        }}</b-td>
                        <b-td
                          ><img
                            id="copy_swift"
                            class="copy"
                            alt="Copy to Clipboard"
                            v-bind:src="getSrc('copy.svg')"
                            v-clipboard="companyInfo.swift"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          />
                          <b-tooltip target="copy_swift" triggers="hover">{{
                            $t("views.deposit.copyToClipboard5")
                          }}</b-tooltip>
                          <b-tooltip target="copy_swift" triggers="click">{{
                            $t("views.deposit.copiedToClipboard3")
                          }}</b-tooltip>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t("views.deposit.bankAddress") }}</b-th>
                        <b-td v-model="companyInfo.bankAddress">{{
                          companyInfo.bankAddress
                        }}</b-td>
                        <b-td
                          ><img
                            id="copy_bankaddress"
                            class="copy"
                            alt="Copy to Clipboard"
                            v-b-tooltip.hover
                            :title="$t('views.deposit.copyToClipboard6')"
                            v-bind:src="getSrc('copy.svg')"
                            v-clipboard="companyInfo.bankAddress"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          />
                          <b-tooltip
                            target="copy_bankaddress"
                            triggers="hover"
                            >{{
                              $t("views.deposit.copyToClipboard7")
                            }}</b-tooltip
                          >
                          <b-tooltip
                            target="copy_bankaddress"
                            triggers="click"
                            >{{
                              $t("views.deposit.copiedToClipboard4")
                            }}</b-tooltip
                          >
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t("views.deposit.referenceNo") }}</b-th>
                        <b-td v-model="companyInfo.refNumber">{{
                          companyInfo.refNumber
                        }}</b-td>
                        <b-td
                          ><img
                            id="copy_ref"
                            class="copy"
                            alt="Copy to Clipboard"
                            v-bind:src="getSrc('copy.svg')"
                            v-clipboard="companyInfo.refNumber"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          />
                          <b-tooltip target="copy_ref" triggers="hover">{{
                            $t("views.deposit.copyToClipboard8")
                          }}</b-tooltip>
                          <b-tooltip target="copy_ref" triggers="click">{{
                            $t("views.deposit.copiedToClipboard5")
                          }}</b-tooltip>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </div>
              <div class="col-12 col-md-5 col-lg-5 col-xl-5 right-col">
                <info-block
                  step="7"
                  image="big-safe-box.svg"
                  :title="'views.deposit.bankTransfer'"
                  :description="'views.deposit.infoBlockDescription'"
                ></info-block>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeforeFormHeader from "../components/BeforeFormHeader";
import InfoBanner from "@/components/InfoBanner";
import Loader from "../components/Loader";
import InfoBlock from "@/components/InfoBlock";
import Stepper from "../components/Stepper";
import Vue from "vue";
import Clipboard from "v-clipboard";
import imageMixin from "@/mixins/image";
import loadingMixin from "@/mixins/loading";
import investorStatuses from "@/config/investorStatuses";

Vue.use(Clipboard);
export default {
  components: { InfoBlock, Loader, BeforeFormHeader, Stepper, InfoBanner },
  mixins: [imageMixin, loadingMixin],
  data() {
    return {
      isLoading: true,
      companyInfo: {
        companyName: "Income Company OÜ",
        iban: "LT273750020003743323",
        swift: "VEPALT2X",
        refNumber: "",
        bank: "VERIFIED PAYMENTS JSC",
        bankAddress: "T. Kosciuškos st. 24, 01100 Vilnius, Lithuania",
      },
      step: 1,
      steps: [
        {
          id: 1,
          title: "views.deposit.deposit",
          active: true,
          completed: false,
        },
        {
          id: 2,
          title: "views.deposit.withdraw",
          active: false,
          completed: false,
        },
      ],
      methods: {
        selected: 1,
        options: [
          {
            value: "1",
            text: this.$t("views.deposit.bankTransfer"),
            instruction: this.$t("views.deposit.instruction"),
            instructionDeposit: this.$t("views.deposit.instructionDeposit"),
          },
        ],
      },
      instruction: "",
      instructionDeposit: "",
    };
  },
  mounted() {
    this.isLoading = !this.loaded;
    this.instruction = this.methods.options[0].instruction;
    this.instructionDeposit = this.methods.options[0].instructionDeposit;
  },
  computed: {},
  watch: {
    loaded: function () {
      this.isLoading = !this.loaded;
      if (this.loaded) {
        if (
          this.$store.state.investors.investor &&
          this.$store.state.investors.investor.investor_account_status
        ) {
          const accountStatus =
            this.$store.state.investors.investor.investor_account_status;
          if (
            accountStatus !== investorStatuses.APPROVED &&
            accountStatus !== investorStatuses.INVESTMENT_SUSPENDED
          ) {
            // this.$router.push('/account')
          }
        }
        this.companyInfo.refNumber =
          this.$store.state.investors.investor.investor_ref_number;
      }
    },
    "methods.selected": function (selected) {
      const depositMethodIndex = this.methods.options.findIndex(
        (o) => o.value === selected
      );
      this.instruction =
        this.methods.options[depositMethodIndex].instruction || "";
    },
    step: function (number) {
      if (number === 2) {
        this.$router.history.push("/withdraw");
      }
    },
  },
  methods: {
    setStep(number) {
      this.step = number;
    },
    clipboardSuccessHandler({ value, event }) {
      setTimeout(() => {
        event.target.src = this.getSrc("copy.svg");
        this.$root.$emit("bv::hide::tooltip", event.target.id);
      }, 1500);
      event.target.src = this.getSrc("completed.svg");
      // console.log('success', value)
    },
    clipboardErrorHandler({ value, event }) {
      console.error("Something wrong with copy from clipboard", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-select {
  margin-left: 10px;
  min-height: 50px;
}

.right-col {
  max-width: 328px;
  //background: #FFFFFF;
  border-radius: 4px;
  min-height: 359px;
  text-align: center;

  h4 {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    font-feature-settings: "liga" off;
    color: #000000;
  }

  img {
    padding-top: 5px;
  }
}

.copy {
  cursor: pointer;
  width: 20px;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .company-info {
    font-size: 12px;

    th,
    td {
      padding: 0.35rem;
    }
  }
}
</style>
